import { render, staticRenderFns } from "./MainInfoColumnAll.vue?vue&type=template&id=4f16b3a0&scoped=true&"
import script from "./MainInfoColumnAll.vue?vue&type=script&lang=js&"
export * from "./MainInfoColumnAll.vue?vue&type=script&lang=js&"
import style0 from "./MainInfoColumnAll.vue?vue&type=style&index=0&id=4f16b3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16b3a0",
  null
  
)

export default component.exports